import React, { Fragment, ReactElement } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es";
import MaskedInput from 'react-text-mask';
import Styles from "./InputTextDate.module.scss";

registerLocale("es", es);

interface InputTextDateProps {
    id: string,
    name: string,
    onChange: any,
    onBlur: any,
    styleClass: string,
    value: Date | null,
    dateFormat: string,
    icon: ReactElement,
    mask: (string | RegExp)[],
    position: string,
    tabIndex?: number,
    placeholderText?: string
}
const InputTextDate: React.FC<InputTextDateProps> = (props: InputTextDateProps) => {
  const { id, name, onChange, onBlur, styleClass, value,
          dateFormat, icon, mask, position, tabIndex, placeholderText } = props
  return (
    <Fragment>
      <div className={Styles.inputGroup}>
          <div className={Styles.icon + " " + Styles.iconCalendar}>
              {icon}
          </div>
          <div className={Styles.customDatePickerWidth}>
            <DatePicker className={Styles.inputIcon + " " + styleClass}
              selected={value}
              onChange={onChange}
              onBlur={onBlur}
              id={id}
              name={name}
              dateFormat={dateFormat}
              customInput={<MaskedInput mask={mask} />}
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              locale='es'
              popperPlacement={position}
              tabIndex={tabIndex}
              shouldCloseOnSelect
              placeholderText={placeholderText}
            />
          </div>
       </div>
    </Fragment>
  );
};

export default InputTextDate;